@if (state.loading === true) {
    <p-progressSpinner class="ps">
    </p-progressSpinner>
}
@else {
    @if (state.viewInfo != null) {
        <app-info-card [title]="state.viewInfo.title" [text]="state.viewInfo.text" [icon]="state.viewInfo.icon"></app-info-card>
    }
    @if (state.loading === false){
        <ng-container *ngTemplateOutlet="content"></ng-container>
    }
}